// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-Footer----footer-module---footer---3YcZG","container":"src-components-Footer----footer-module---container---SePS1 src-styles----global---centredContainer---3bAlq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.module.scss
// module id = 273
// module chunks = 114276838955818